
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export const Data = { 
    TemplateIds: {
        
        AccordionItem : "3FD5EE96545E40809E31325F37FBA41B",
        Author : "1DC2AAD35976476A9CE76E8D7030E71D",
        AuthorFolder : "2E060AF86C114B499DF0041E7A5E7EC9",
        CarouselItem : "8B0D87654B2740D293CA6BD59C2BD6D0",
        CenterTypeColumn : "62277667A45F4F3ABDB1B218ACAD85F0",
        Column : "5F1F5703D9C842778F3750FE565732D1",
        CustomTagFolder : "5032E1540FFA4B2394C6FC4460673D55",
        EventCategory : "AF10BF690CB64256BECD0717D766ADFC",
        EventCategoryFolder : "12B1E7C6EB534296ADADE807F48D324B",
        FaqSchema : "985CA2578BA24156ABEFA736D07B5E0E",
        FaqSchemaQuestionItem : "69765AB6517945D3B87A51B187D2809F",
        NavigationFooter : "DB55CF332F2D4106BF6CC5F49D2DF033",
        NavigationHeader : "3C81B8909E2C4CBD9392380492278754",
        NavigationLink : "8842DDA37E784CE7AB78F48A4C085808",
        NavigationLinkFolder : "032F3879E0A6451C8794A515C0E8F52D",
        OrganizationSchema : "DEDE602B0B024D389D27E92EB8748BCB",
        PageSchema : "D8AB713AA0A94768891F82981B027C8B",
        RedirectFolder : "34D2D3DC811542BAB66E2BBF41544D51",
        RedirectItem : "20D997C6B8894C7CBCEC1337AEAD6E77",
        Row : "BE9DF0E5C3D3462BB85AAD3196DE2AB5",
        SitewideConfiguration : "FA2A5EB0393E4154BD0B439D72561EC3",
        SocialFolder : "AFAA62368E0C42FDBBD768144EBF8008",
        SocialLinks : "9AE07CF12BE64C419EFD0B1DCAA574A4",
        TabsItem : "8B4B09511BB54E908B7085A8A1E029A0",
        Taxonomy : "73FAB6BE69C5415B850201DC085093BF",
        TaxonomyFolder : "F3CE18217F7D4191AD1604B740E4A15B",
        TimelineItem : "AB650C451B914940B98A59B11E936A6E",
        VideoItem : "7536FE7DA60E4B798A0507722D189545",
        Profile : "F07D7BBC133D40538691B0221AC79CBC",
        ProfileLinks : "4138B3381A8B46329D9F873BFBF679D9"    
    }
}


